import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import React from 'react'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import useSBMCheck from '@chegg-wt/core/hooks/useSBMCheck'
import { useRouter } from 'next/router'
import { isSameOrigin, decodeQueryParam } from '@chegg-wt/core/utils/url'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import OneAuth from '@chegg-wt/core/components/Auth'

type QueryParams = {
  redirect?: string
}

const Register = () => {
  useSBMCheck()
  const router = useRouter()
  const { redirect } = router.query as QueryParams
  const decodedRedirect = decodeQueryParam(redirect)
  const { toFolders } = useRoutesContext()
  const redirectTo =
    decodedRedirect && isSameOrigin(decodedRedirect)
      ? { href: decodedRedirect }
      : toFolders()
  useOnUnloadTimeOnPage()

  return (
    <>
      <SEOTitle title="Register | Cite This For Me" />
      <OneAuth defaultflow="signup" redirectTo={redirectTo} />
    </>
  )
}

export default Register
